import type {ReactElement} from 'react';
import React from 'react';
import {VectorOutlineColorOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/vector-outline-color-option';
import {VectorThicknessOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/vector-thickness-option';

interface VectorBorderOptionsProps {
  panelId: string;
  onClickColorFill(): void;
}

export function VectorBorderOptions({...props}: VectorBorderOptionsProps): ReactElement | null {
  const getBorderThicknessOption = (): ReactElement => {
    return <VectorThicknessOption />;
  };

  const getColorOutlineOption = (): ReactElement => {
    return (
      <VectorOutlineColorOption
        onClickColorOption={(): void => {
          props.onClickColorFill();
        }}
        className="spacing-m-b-4"
      />
    );
  };

  return (
    <>
      {getColorOutlineOption()}
      {getBorderThicknessOption()}
    </>
  );
}
